import Vue from 'vue';

/**
 * UniMicro Authorization
 * Sends client credentials to get UniMicro login URL
 */
const success = function success(response, resolve) {
  resolve(response);
};

const failed = function failed(error, reject) {
  reject(error);
};

export default function numberSeries(data) {
  return new Promise((resolve, reject) => {
    Vue.$http
      .get('/unimicro/number-series', data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  });
}



// WEBPACK FOOTER //
// ./src/app/services/unimicro/numberSeries.js